module.exports = __webpack_public_path__ + "static/charla-jorge-sociales-8868e83378e4bd3983f7dd3adf299b81.jpeg";